module.exports = __webpack_public_path__ + "../resources/images/celebrate-ad5686923ad5be08aadd34f7aad4899e.svg";